<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item>产品配置</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">产品配置</h2>
        </div>
        <div class="right">
        </div>
      </div>
    </div>
    <div class="results card">
      <el-tabs v-model="query.tabKey" @tab-click="handleTabChange">
        <el-tab-pane label="题库配置" name="exam"></el-tab-pane>
        <el-tab-pane label="课程配置" name="course"></el-tab-pane>
        <el-tab-pane label="阅读资料配置" name="read"></el-tab-pane>
        <el-tab-pane label="实体资料配置" name="material"></el-tab-pane>
      </el-tabs>
      <div class="values">
        <ExamConfig v-if="query.tabKey == 'exam'"></ExamConfig>
      </div>
    </div>
  </div>
</template>

<script>
import ExamConfig from './examConfig'

export default {
  components: {
    ExamConfig
  },
  data() {
    return {
      query: {
        tabKey: 'exam'
      }
    }
  },
  created() {
    this.parseQuery()
  },
  methods: {
    handleTabChange(tab) {
      this.query.tabKey = tab.name
      this.syncQuery()
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach(key => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(key => this.$route.query[key] != this.query[key])
      isSync && this.$router.replace({
        query: Object.assign({}, this.$route.query, this.query)
      })
    },
  }
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #FFF;
    border: 1px solid #EBEEF5;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {

    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
